"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardInfo = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var user_1 = require("../../model/user");
var service_1 = require("../../../library/base/service");
var CardInfo = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CardInfo, _super);
    function CardInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '会员卡详情信息';
        _this.code = '301149';
        _this.desc = '会员卡详情信息';
        _this.requestParams = new user_1.CardInfoRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CardInfo;
}(service_1.BaseService));
exports.CardInfo = CardInfo;
//# sourceMappingURL=CardInfo.js.map